import React, { Component } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Link
} from 'react-router-dom'

import AdminApp from './admin/AdminApp'
import CompanyAdminApp from './company_admin/CompanyAdminApp'
import CompanyUserApp from './company_user/CompanyUserApp'
import PrintApp from './company_user/PrintApp'

import Dialog from './common/component/Dialog'

import Help001 from './help/Help001'
import Help002 from './help/Help002'
import Help003 from './help/Help003'
import Help004 from './help/Help004'
import Help005 from './help/Help005'
import Help006 from './help/Help006'
import Help007 from './help/Help007'
import Help008 from './help/Help008'
import Help009 from './help/Help009'
import Help010 from './help/Help010'

import HelpCA001 from './help/HelpCA001'
import HelpCA002 from './help/HelpCA002'

import './common/style/Base.css'
import './common/style/App.css'

const Home = () => (
  <div>
    <div id='body-container'>
      <div id='body-content'>
        <div className='container'>
          <div className='signin-row container-signin'>
            <div className='logo'><img src='./images/logo.png' alt='ロゴ' /><span>日本型枠工事業協会</span></div>
            <div className='button-area'>
              <Link to={'/company_user'}><button type='button' className='btn btn-primary'>一般ユーザの方</button></Link><br /><Link to={'/company_admin'}><button type='button' className='btn btn-success'>企業の管理者の方</button></Link><br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

const ChromeDownloadAlert = (
  <div id='body-container'>
    <div id='body-content'>
      <div className='container'>
        <div className='signin-row'>
          <div className='logo'><img src='/images/logo.png' alt='ロゴ' /><span>日本型枠工事業協会</span></div>
          <div className='well well-small well-shadow'>
            <legend className='lead'>使用上の注意</legend>
            <p className='text-caution'>このシステムの対応ブラウザ(*1)は、Chromeです。<br />
            他のブラウザでの動作は保証しておりません。</p>
            <p className='text-underline'><a target='_blank' href='https://www.google.com/chrome/browser/desktop/index.html'>こちらから最新のChromeをダウンロードしてご利用ください。</a></p>
            <p className='text-small'> *1 ブラウザとは、Chrome、Internet Explorer、Firefox、Safariなどのインターネット上のサイトを閲覧する際に使用するプログラムのことです</p>
          </div>
        </div>
      </div>
    </div>
  </div>
)

const checkUserAgent = () => {
  const userAgent = window.navigator.userAgent.toLowerCase()
  let ua
  if (userAgent.indexOf('msie') !== -1 ||
          userAgent.indexOf('trident') !== -1) {
    ua = 'ie'
  } else if (userAgent.indexOf('edge') !== -1) {
    ua = 'edge'
  } else if (userAgent.indexOf('chrome') !== -1) {
    ua = 'chrome'
  } else if (userAgent.indexOf('safari') !== -1) {
    ua = 'safari'
  } else if (userAgent.indexOf('firefox') !== -1) {
    ua = 'firfox'
  } else if (userAgent.indexOf('opera') !== -1) {
    ua = 'opera'
  } else {
    ua = 'others'
  }
  return (ua === 'chrome')
}

class App extends Component {
  render () {
    if (!checkUserAgent()) {
      return <div>{ChromeDownloadAlert}</div>
    }
    return (
      <div>
        <Router>
          <Switch>
            <Route exact path='/' component={Home} />

            <Route exact path='/admin/help/help007' component={Help007} />
            <Route exact path='/admin/help/help008' component={Help008} />
            <Route exact path='/admin/help/help009' component={Help009} />
            <Route exact path='/admin/help/help010' component={Help010} />

            <Route path='/admin' component={AdminApp} />

            <Route exact path='/company_admin/help/helpCA001' component={HelpCA001} />
            <Route exact path='/company_admin/help/helpCA002' component={HelpCA002} />
            <Route exact path='/company_admin/help/help007' component={Help007} />
            <Route exact path='/company_admin/help/help008' component={Help008} />
            <Route exact path='/company_admin/help/help009' component={Help009} />
            <Route exact path='/company_admin/help/help010' component={Help010} />

            <Route path='/company_admin' component={CompanyAdminApp} />
            <Route exaxt path='/company_user/estimation/print/:estimationId' component={PrintApp} />

            <Route exact path='/company_user/help/help001' component={Help001} />
            <Route exact path='/company_user/help/help002' component={Help002} />
            <Route exact path='/company_user/help/help003' component={Help003} />
            <Route exact path='/company_user/help/help004' component={Help004} />
            <Route exact path='/company_user/help/help005' component={Help005} />
            <Route exact path='/company_user/help/help006' component={Help006} />
            <Route exact path='/company_user/help/help007' component={Help007} />
            <Route exact path='/company_user/help/help008' component={Help008} />
            <Route exact path='/company_user/help/help009' component={Help009} />
            <Route exact path='/company_user/help/help010' component={Help010} />

            <Route path='/company_user' component={CompanyUserApp} />

          </Switch>
        </Router>
        <Dialog />
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js